import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { fetchExport } from "./initialloadSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  CallApiExport,
  createChangeHandler,
  getValueStatus,
  paramsMasterAll,
  setOptionsMaster,
  showErrorDialog,
} from "../../utility";
import { InitialloadTable } from "./InitialloadTable";
import {
  fetchData,
  selectDataUser,
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
} from "../user/userSlice";
import { fetchBranch, selectBranch } from "../branch/branchSlice";
import Select from "react-select";

export const InitialloadPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectDataUser);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataBranch = useSelector(selectBranch);

  // Filter
  const [code, setCode] = useState("");
  const [name, setName] = useState("");

  const [branch, setBranch] = useState("");
  const [optionsBranch, setOptionBranch] = useState([]);
  const handleChangeBranch = createChangeHandler(setBranch);

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(
        fetchData({
          pageNo: 1,
          pageSize: 10,
          roles_in: "COMPANY_SALES,COMPANY_SUPERVISOR",
          sales_type: "CANVAS",
        })
      );
      await dispatch(fetchBranch({ ...paramsMasterAll }));
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataBranch && dataBranch.length > 0) {
      setOptionsMaster(
        dataBranch,
        setOptionBranch,
        "branch_code",
        "branch_name"
      );
    }
  }, [dataBranch]);

  const paramsFilter = {
    company_sales_code: code,
    name: name,
    roles_in: "Company Sales, COMPANY SUPERVISOR",
    sales_type: "CANVAS",
    branch_code: branch,
    is_active: true,
  };

  const handleSearch = async () => {
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        })
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Initial Load Setting">
        <CardHeaderToolbar>
          <Button
            className="btn btn-outline-danger mr-4"
            onClick={() =>
              CallApiExport(
                paramsFilter,
                fetchExport,
                dispatch,
                "Initial_Load_Setting"
              )
            }
          >
            Export
          </Button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/* Filter */}
        <Form className="mb-5">
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Sales Code</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Branch</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionsBranch}
                    value={getValueStatus(branch, optionsBranch)}
                    placeholder="Select ..."
                    onChange={handleChangeBranch}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}

            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Sales Name</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm={3}>
                  <Button
                    className="btn btn-outline-danger"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Col>
                {/* <Col sm={3}>
                  <Button
                    className="btn btn-warning"
                    onClick={() => history.push("/masterdata/vendor-create")}
                  >
                    Create
                  </Button>
                </Col> */}
              </Form.Group>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}

        <InitialloadTable
          data={Array.isArray(data) ? data : []}
          page={pageNo}
          sizePerPage={pageSize}
          totalSize={totalRecord}
          onTableChange={handleTableChange}
          loading={loading}
        />
      </CardBody>
    </Card>
  );
};
